import { DGARadioInput } from "components/Shared/dga-radio-input/DGARadioInput";

import { VotingOption } from "../Helpers/VotingSectionHelpers";

type VotingRadioButtonsOptionsProps = {
  options: VotingOption[];
  selectedOptionIds: string[];
  onSelectOption: (optionId: string) => void;
  sectionId: string;
  votingOptionsTitle?: string;
};

export const VotingRadioButtonsOptions = ({
  options,
  selectedOptionIds,
  onSelectOption,
  sectionId,
  votingOptionsTitle,
}: VotingRadioButtonsOptionsProps) => {
  if (!options.length) return null;

  const baseId = `${sectionId}-voting-radios`.replace(/ /g, "-");
  const groupName = `${baseId}-group`;

  return (
    <div className="flex flex-col gap-5 px-2 py-4">
      {votingOptionsTitle && (
        <p className="text-sm font-semibold text-primary-1000">{votingOptionsTitle}</p>
      )}

      <div className="flex flex-col gap-3">
        {options.map((option) => {
          const description = option.fields?.Description?.value;
          if (!description) return null;

          const inputId = `${baseId}-${option.id}`;
          const isSelected = selectedOptionIds.includes(option.id);

          return (
            <div key={option.id} className="flex items-center gap-2">
              <DGARadioInput
                variant="primary"
                size="md"
                id={inputId}
                name={groupName}
                checked={isSelected}
                onChange={() => onSelectOption(option.id)}
                aria-label={description}
              />
              <label htmlFor={inputId} className="cursor-pointer text-sm text-primary-1000">
                {description}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
};
